import { AfterViewChecked, Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Entry } from 'contentful';
import { OrderChangeNotifRegisterLabels } from 'src/app/model/page/group/forms/order-change-notif/order-change-notif-register-labels';
import { OrderChangeNotifRequest } from 'src/app/model/page/group/forms/order-change-notif/order-change-notif-request';
import { OrderChangeNotifRegistrationPage } from 'src/app/model/page/group/forms/order-change-notif-registration-page';
import { ApiService } from 'src/app/service/api.service';
import { entraAuthService } from 'src/app/service/auth.service';
import { ContentfulService } from 'src/app/service/contentful.service';
import { SandboxPageStateService } from 'src/app/service/sandbox-page-state.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-order-change-notif-registration-page',
  templateUrl: './order-change-notif-registration-page.component.html',
  styleUrls: ['./order-change-notif-registration-page.component.scss']
})
export class OrderChangeNotifRegistrationPageComponent implements OnInit, AfterViewChecked {
  orderChangeNotifRegistrationPage: OrderChangeNotifRegistrationPage = {} as OrderChangeNotifRegistrationPage;
  orderChangeNotifRequest: OrderChangeNotifRequest = {} as OrderChangeNotifRequest;
  OCNregisterLabels: OrderChangeNotifRegisterLabels = {} as OrderChangeNotifRegisterLabels;
  orderChageNotifRegisterForm: FormGroup = new FormGroup({
    contactName: new FormControl(''),
    contactEmail: new FormControl(''),
    agencyName: new FormControl(''),
    environment: new FormControl(''),
    IATAserviceProvider: new FormControl(''),
    masheryClientKey: new FormControl(''),
    masheryUserName: new FormControl(''),
    soapAction: new FormControl(''),
    endpointUrl: new FormControl(''),
    userName: new FormControl(''),
    clientSecret: new FormControl(''),
    protocol: new FormControl('SOAP'),
    authenticationMethod: new FormControl('BASIC'),
    tokenServiceUrl: new FormControl('')
  });
  submitted = false;
  showPassword = false;
  showText = false;
  IATAAdded = false;
  showClientSecret = false;
  orderChangeNotifSuccess = false;
  showDuplicateVoucherError = false;
  orderChangeNotifError = '';
  IATANumbers: any = [];
  constructor(private contentfulService: ContentfulService, private formBuilder: FormBuilder, private apiService: ApiService, private auth: entraAuthService, private sandboxPageStateService: SandboxPageStateService) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'order-change-notif-registration') {
        this.orderChangeNotifRegistrationPage.htmlTitle = title.htmlTitle;
      }
    });
    const query = { 'fields.title': 'OrderChangeNotif Registration Form' };
    this.contentfulService.getPageContentResponse(query).then((orderChangeNotifRegistrationPageEntries) => {
      this.mapBanner(orderChangeNotifRegistrationPageEntries.includes.Entry);
      this.mapHtmlTitle(orderChangeNotifRegistrationPageEntries.items);
    });
    this.mapOCNRegistrationLabels();
    this.orderChageNotifRegisterForm = this.formBuilder.group({
      contactName: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(30)]],
      contactEmail: ['', [Validators.required, Validators.email]],
      agencyName: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(100)]],
      IATAserviceProvider: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(8), Validators.pattern(/\-?\d*\.?\d{1,2}/)]],
      environment: ['TEST', [Validators.required]],
      masheryClientKey: ['', [Validators.required, Validators.minLength(24), Validators.maxLength(255), Validators.pattern(/\-?\d*\.?\d{1,2}/)]],
      masheryUserName: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(255)]],
      tokenServiceUrl: [{ value: '', disabled: true }, [Validators.required, Validators.pattern('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?')]],
      soapAction: ['', [Validators.required]],
      endpointUrl: ['', [Validators.required, Validators.pattern('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?')]],
      userName: ['', [Validators.required, Validators.minLength(4)]],
      clientSecret: ['', [Validators.required, Validators.minLength(4), Validators.pattern(/^[a-zA-Z0-9!~@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/)]],
      protocol: ['SOAP', [Validators.required]],
      authenticationMethod: ['BASIC', [Validators.required]]
    });
  }
  ngAfterViewChecked(): void {
    localStorage.removeItem('redirect_url');
  }

  private mapHtmlTitle(items: Entry<any>[]) {
    items.forEach((entry: any) => {
      this.orderChangeNotifRegistrationPage.htmlTitle = entry.fields.htmlTitle;
    });
  }

  private mapBanner(orderChangeNotifRegistrationPageEntries: Entry<any>[]) {
    orderChangeNotifRegistrationPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let imageDetails: any = entry.fields['image'];
    let videoDetails: any = entry.fields['video'];

    this.orderChangeNotifRegistrationPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: imageDetails.fields.file.url,
      video: videoDetails?.fields?.file?.url
    };
  }

  get f(): { [key: string]: AbstractControl } {
    return this.orderChageNotifRegisterForm.controls;
  }

  async submitOrderChangeNotif() {
    this.submitted = true;
    this.orderChageNotifRegisterForm.get('IATAserviceProvider')?.clearValidators();
    this.orderChageNotifRegisterForm.get('IATAserviceProvider')?.updateValueAndValidity();
    if (this.IATANumbers.length === 0) {
      return;
    }
    if (this.orderChageNotifRegisterForm.valid) {
      this.orderChangeNotifRequest.environment = this.orderChageNotifRegisterForm.value.environment;
      this.orderChangeNotifRequest.agencyName = this.orderChageNotifRegisterForm.value.agencyName;
      this.orderChangeNotifRequest.contactName = this.orderChageNotifRegisterForm.value.contactName;
      this.orderChangeNotifRequest.contactEmail = this.orderChageNotifRegisterForm.value.contactEmail;
      this.orderChangeNotifRequest.ndcAPIusername = this.orderChageNotifRegisterForm.value.masheryUserName;
      this.orderChangeNotifRequest.ndcAPIpwd = this.orderChageNotifRegisterForm.value.masheryClientKey;
      this.orderChangeNotifRequest.iataServiceProviders = this.IATANumbers;
      this.orderChangeNotifRequest.protocol = this.orderChageNotifRegisterForm.value.protocol;
      this.orderChangeNotifRequest.endPointURL = this.orderChageNotifRegisterForm.value.endpointUrl;
      this.orderChangeNotifRequest.soapAction = this.orderChageNotifRegisterForm.value.soapAction;
      this.orderChangeNotifRequest.authenticationMethod = this.orderChageNotifRegisterForm.value.authenticationMethod;
      this.orderChangeNotifRequest.apiCredentials = {
        tokenServiceURL: this.orderChageNotifRegisterForm.value.tokenServiceUrl,
        clientKey: this.orderChageNotifRegisterForm.value.userName,
        clientSecret: this.orderChageNotifRegisterForm.value.clientSecret
      };

      const apiResponse = await this.apiService.sendPostRequest(this.orderChangeNotifRequest, '/ocn');
      if (apiResponse.error) {
        if (apiResponse.error.error) {
          this.orderChangeNotifError = apiResponse.error.message;
        }
        if (apiResponse.error.status == 401) {
          localStorage.setItem('redirect_url', '/orderChangeNotif/register');
          this.auth.initLogin();
        }
        setTimeout(() => {
          this.orderChangeNotifError = '';
        }, 2400);
      } else {
        this.orderChangeNotifSuccess = true;
      }
    }
  }

  public togglePassword() {
    this.showPassword = !this.showPassword;
  }
  public toggleMasheryText() {
    this.showText = !this.showText;
  }
  public toggleClientSecret() {
    this.showClientSecret = !this.showClientSecret;
  }
  addIATA() {
    this.IATAAdded = true;
    this.orderChageNotifRegisterForm.get('IATAserviceProvider')?.setValidators([Validators.required, Validators.minLength(8), Validators.maxLength(8), Validators.pattern(/\-?\d*\.?\d{1,2}/)]);
    if (this.orderChageNotifRegisterForm.get('IATAserviceProvider')?.value && this.orderChageNotifRegisterForm.get('IATAserviceProvider')?.valid) {
      if (!this.IATANumbers.find((ticketNum: any) => ticketNum == this.orderChageNotifRegisterForm.get('IATAserviceProvider')?.value)) {
        this.IATANumbers.push(this.orderChageNotifRegisterForm.get('IATAserviceProvider')?.value);
      } else {
        this.showDuplicateVoucherError = true;
      }
      this.orderChageNotifRegisterForm.get('IATAserviceProvider')?.reset();
      this.IATAAdded = false;
    }
  }
  delIATAnum(IATAnum: string) {
    const index: number = this.IATANumbers.indexOf(IATAnum);
    if (index !== -1) {
      this.IATANumbers.splice(index, 1);
    }
  }
  // Only Integer Numbers
  keyPressNumbers(event: any) {
    var charCode = event.which ? event.which : event.keyCode;
    // Only Numbers 0-9
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }
  private mapOCNRegistrationLabels() {
    const query = { 'fields.title': 'OrderChangeNotif Registration Form' };
    this.contentfulService.getPageContentWithItems(query).then((labelItems) => {
      // console.log(labelItems[0]?.fields.constants);
      this.mapLables(labelItems[0]?.fields.constants);
      if (this.OCNregisterLabels.optionTEST?.length) {
        this.orderChageNotifRegisterForm.get('environment')?.setValue(this.OCNregisterLabels.optionTEST[0]);
      }
    });
  }
  mapLables(labels: any) {
    this.OCNregisterLabels = {
      mainHeading: labels.mainHeading,
      note: labels.note,
      Environment: labels.Environment,
      optionTEST: labels.optionTEST,
      optionLIVE: labels.optionLIVE,
      AgencyNameServiceProvider: labels.AgencyNameServiceProvider,
      ContactName: labels.ContactName,
      ContacteMail: labels.ContacteMail,
      MasheryUserName: labels.MasheryUserName,
      MasheryPackageKey: labels.MasheryPackageKey,
      IATAServiceProvider: labels.IATAServiceProvider,
      add: labels.add,
      Protocol: labels.Protocol,
      optionSOAP: labels.optionSOAP,
      optionREST: labels.optionREST,
      EndPointURL: labels.EndPointURL,
      SoapAction: labels.SoapAction,
      AuthenticationMethod: labels.AuthenticationMethod,
      optionBasicAuth: labels.optionBasicAuth,
      optionOAuth20: labels.optionOAuth20,
      APICredentialsHeading: labels.APICredentials.heading,
      TokenServiceURL: labels.APICredentials.TokenServiceURL,
      UserNameClientKey: labels.APICredentials.UserNameClientKey,
      PasswordClientSecret: labels.APICredentials.PasswordClientSecret,
      submit: labels.submit,
      successMsg: labels.successMsg,
      invalidAgencyName: labels.errorMessages.invalidAgencyName,
      invalidContactName: labels.errorMessages.invalidContactName,
      invalidMailAdress: labels.errorMessages.invalidMailAdress,
      invalidMasheryUsername: labels.errorMessages.invalidMasheryUsername,
      invalidIATA: labels.errorMessages.invalidIATA,
      invalidEndpointUrl: labels.errorMessages.invalidEndpointUrl,
      invalidSOAPtext: labels.errorMessages.invalidSOAPtext,
      invalidTokenServiceUrl: labels.errorMessages.invalidTokenServiceUrl,
      invalidClientKey: labels.errorMessages.invalidClientKey,
      invalidClientSecret: labels.errorMessages.invalidClientSecret
    };
  }
  disableSoapAction() {
    if (this.orderChageNotifRegisterForm.get('protocol')?.value === 'REST') {
      this.orderChageNotifRegisterForm.get('soapAction')?.clearValidators();
      this.orderChageNotifRegisterForm.get('soapAction')?.updateValueAndValidity();
      this.orderChageNotifRegisterForm.get('soapAction')?.disable();
    }
  }
  enbleSoapAction() {
    if (this.orderChageNotifRegisterForm.get('protocol')?.value === 'SOAP') {
      this.orderChageNotifRegisterForm.get('soapAction')?.setValidators([Validators.required]);
      this.orderChageNotifRegisterForm.get('soapAction')?.updateValueAndValidity();
      this.orderChageNotifRegisterForm.get('soapAction')?.enable();
    }
  }
  enableAuth() {
    if (this.orderChageNotifRegisterForm.get('authenticationMethod')?.value === 'oAUTH2') {
      this.orderChageNotifRegisterForm.get('tokenServiceUrl')?.setValidators([Validators.required, Validators.pattern('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?')]);
      this.orderChageNotifRegisterForm.get('tokenServiceUrl')?.updateValueAndValidity();
      this.orderChageNotifRegisterForm.get('tokenServiceUrl')?.enable();
    }
  }
  disableAuth() {
    if (this.orderChageNotifRegisterForm.get('authenticationMethod')?.value === 'BASIC') {
      this.orderChageNotifRegisterForm.get('tokenServiceUrl')?.clearValidators();
      this.orderChageNotifRegisterForm.get('tokenServiceUrl')?.updateValueAndValidity();
      this.orderChageNotifRegisterForm.get('tokenServiceUrl')?.disable();
    }
  }
  clearErrorMesssage() {
    this.showDuplicateVoucherError = false;
    this.IATAAdded = false;
  }
  keyPressSpace(event: any) {
    var charCode = event.which ? event.which : event.keyCode;

    if (charCode === 32) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }
}
